// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"57e47e04","325":"8f562988","483":"14adfcbc","490":"868a0215","541":"572c3d84"}[chunkId] + ".chunk.js";
};